import { render, staticRenderFns } from "./ProfileBody.vue?vue&type=template&id=2c8848d8&"
import script from "./ProfileBody.vue?vue&type=script&lang=js&"
export * from "./ProfileBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports